"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MouseEventPolyfill = function (eventType, params) {
    if (params === void 0) { params = {}; }
    var mouseEvent = document.createEvent('MouseEvent');
    mouseEvent.initMouseEvent(eventType, params.bubbles || true, params.cancelable || true, document.defaultView, 
    // coordinates
    null, 0, 0, 0, 0, 
    // modifier keys
    params.ctrlKey || false, params.altKey || false, params.shiftKey || false, params.metaKey || false, 
    // mouse button
    params.button || 0, null);
    return mouseEvent;
};
exports.default = MouseEventPolyfill;
//# sourceMappingURL=mouse-event.js.map